export enum MasterTablePermissions {
	ChMasterTabels = "ChMasterTabels",
	ChIncuranceClasses = "ChIncuranceClasses",
	ChCustomerServiceModule = "ChCustomerServiceModule",
	ChInsuranceCompanies = "ChInsuranceCompanies",
	ChProductionBusinessModules = "ChProductionBusinessModules",
	ChInsuranceBrokers = "ChInsuranceBrokers",
	ChClaimsModule = "ChClaimsModule",
	ChListOfRequiredDocuments = "ChListOfRequiredDocuments",
	ChBusinessActivity = "ChBusinessActivity",
	ChContactsListPosition = "ChContactsListPosition",
	ChClientsCategories = "ChClientsCategories",
	ChCountries = "ChCountries",
	ChDefaultEmails = "ChDefaultEmails",
	ChTypeProspects = "ChTypeProspects",
	ChMasterTablesReadOnly = "ChMasterTablesReadOnly",
	ChAccessAllProducersSales = "ChAccessAllProducersSales",
}
